// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-included-tournaments__title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
    margin-bottom: 12px;
}

.payment-included-tournaments__title .baloa-table {
    color: var(--basic-gray-color);
}

.payment-included-tournaments__title .icon-trophy {
    color: var(--basic-gray-color);
    font-size: 20px;
}

.payment-included-tournaments__tournament {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 6px;
    margin-bottom: 24px;
}

.payment-included-tournaments__tournament-img img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.payment-included-tournaments__tournament-img .icon-ball {
    color: var(--white-color );
    font-size: 32px;
    border-radius: 50%;
    padding: 4px;    
}

.payment-included-tournaments__tournament-data .baloa-table {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
}

.payment-included-tournaments__tournament-data__char {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 4px;
    gap:4px ;
}

.payment-included-tournaments__tournament-data__char .baloa-mini {
    color: var(--primary-dark-color);
    padding: 3px 6px;
    border-radius: 25px;
    background-color: var(--new-background-color);
    border: 1px solid var(--new-gray-color );
    white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/payments/components/payment-included-tournaments/PaymentIncludedTournamentsComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,6CAA6C;IAC7C,wCAAwC;IACxC,mBAAmB;AACvB","sourcesContent":[".payment-included-tournaments__title {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 4px;\n    margin-bottom: 12px;\n}\n\n.payment-included-tournaments__title .baloa-table {\n    color: var(--basic-gray-color);\n}\n\n.payment-included-tournaments__title .icon-trophy {\n    color: var(--basic-gray-color);\n    font-size: 20px;\n}\n\n.payment-included-tournaments__tournament {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 6px;\n    margin-bottom: 24px;\n}\n\n.payment-included-tournaments__tournament-img img {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.payment-included-tournaments__tournament-img .icon-ball {\n    color: var(--white-color );\n    font-size: 32px;\n    border-radius: 50%;\n    padding: 4px;    \n}\n\n.payment-included-tournaments__tournament-data .baloa-table {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n}\n\n.payment-included-tournaments__tournament-data__char {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    margin-top: 4px;\n    gap:4px ;\n}\n\n.payment-included-tournaments__tournament-data__char .baloa-mini {\n    color: var(--primary-dark-color);\n    padding: 3px 6px;\n    border-radius: 25px;\n    background-color: var(--new-background-color);\n    border: 1px solid var(--new-gray-color );\n    white-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
